/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col flex-column">
      {{Itemize.travel_title}}
      <span></span>
    </li>
    <li class="w-50 list-item-col">
      {{Itemize.date_in | formatTimestamp}} / {{Itemize.date_out | formatTimestamp}}
    </li>
    <li class="w-50 list-item-col">{{Itemize.num}} 人</li>
    <li class="w-50 list-item-col">{{Itemize.order_type | formatVar('OrderType')}} ({{Itemize.team_type==2?'会议团':'旅游团'}})</li>
    <li class="w-50 list-item-col" v-if="Itemize.deal_time==0">暂无</li>
    <li class="w-50 list-item-col" v-else>{{Itemize.deal_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col" :class="[$GFUN.FormatColor(Itemize.status)]">{{Itemize.status | formatVar('HOrderStatus')}}</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeHotel',
    props:{
      Itemize:{}
    },
  }
</script>
